import React from 'react';
import {Chip} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {dashboardHelper} from '../utils/dashboardHelper.js';

/**
 * Heure de début prévue d'une tournée (« Début 6h30 »), à côté de son libellé.
 * Ne rend rien si la tournée n'a pas d'heure — la valeur venait autrefois du titre de la tournée.
 */
function HeureDebutChip({heureDebut, size = 'small', sx}) {
    const heure = dashboardHelper.formatHeureDebut(heureDebut);
    if (!heure) return null;
    return (
        <Chip icon={<AccessTimeIcon/>} label={`Début ${heure}`} size={size} variant="outlined"
              sx={{fontWeight: 'bold', ...sx}}/>
    );
}

export default HeureDebutChip;
